import IfAdmin from '../IfAdmin'
import ColorButton from '../Controls/ColorButton'
import React from 'react'
import { connect } from 'react-redux'
import { startCopyPoll } from '../../stores/polls/copyPoll'

const CopyButton = ({ startCopyPoll, poll }) => (
  <IfAdmin>
    <ColorButton
      colorClass="b-op-brand"
      borderClass="b--black"
      onClick={() => startCopyPoll(poll)}
    >
      Copy poll
    </ColorButton>
  </IfAdmin>
)

export default connect(
  null,
  { startCopyPoll }
)(CopyButton)



// WEBPACK FOOTER //
// ./src/components/PollCopy/CopyButton.js